{
  "version": 1,
  "asset_id": "3cefa84a-4559-489b-af00-996c4e6743ae",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/3cefa84a-4559-489b-af00-996c4e6743ae/silivri-hizli-elektrikci-7-24-dukkan-2.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/3cefa84a-4559-489b-af00-996c4e6743ae/silivri-hizli-elektrikci-7-24-dukkan-2.jpg",
  "original_filename": "silivri-hizli-elektrikci-7-24-dukkan-2.jpg",
  "size": 118776,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:26:37Z"
}
